var React = require('react');

function Submarket (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9,1,2.16,7.41v9H15.84v-9Zm-2.52,12H4.59V10H6.48Zm6.81,0H11.4V10h1.89Z"}));
}

Submarket.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 18 18"};

module.exports = Submarket;

Submarket.default = Submarket;
